import { render, staticRenderFns } from "./TypologyTitle.vue?vue&type=template&id=716598d9&scoped=true&"
import script from "./TypologyTitle.vue?vue&type=script&lang=js&"
export * from "./TypologyTitle.vue?vue&type=script&lang=js&"
import style0 from "./TypologyTitle.vue?vue&type=style&index=0&id=716598d9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716598d9",
  null
  
)

export default component.exports